<template>
  <div class="new-event-hotelsBlock">
    <HotelList :hotels="hotels" :list="list" :title="title" />
  </div>
</template>
<script>
import HotelList from './hotelList.vue'

export default {
  name: 'NewEventHotelsBlock',
  components: {
    HotelList
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    hotels: {
      type: Array,
      default: () => []
    },
    list: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="sass" scoped>
@import '@/assets/style/_mixins.sass'
.new-event-hotelsBlock
  @apply w-full
  .tags
    @apply flex flex-wrap
    gap: 16px
    width: fit-contents
    .tag
      @apply py-8 px-16 border-2 border-grey cursor-pointer
      border-radius: 10px
      &:hover
        @apply border-grey-darkest
</style>
